import Vue from 'vue';
import VueStash from 'vue-stash';

Vue.use(VueStash);

export default {
  user: null, // TODO - Use vuex
};



// WEBPACK FOOTER //
// ./src/state/stash.js